export enum ContactType {
    MobileTextOption = '1',
    EmailPhoneOption = '0',
}
